// extracted by mini-css-extract-plugin
module.exports = {"itemsTotal":"paperAnimalBatch_itemsTotal__1_h1K","label":"paperAnimalBatch_label__Rr-Sy"};